export interface EventFormValues {
	name: string;
	location: string;
	body: string;
	startDate: string;
	startTime: string;
	showStartDate: boolean;
	endDate: string;
	endTime: string;
	showEndDate: boolean;
	tag: string | null;
	image: File | null;
}

export function formValuesToEvent(
	data: EventFormValues,
	id?: number
): Partial<MeeEvent> {
	return {
		...(id !== undefined && { id }),
		name: data.name,
		location: data.location || null,
		body: data.body || null,
		startDate: `${data.startDate}T${data.startTime || "00:00"}`,
		showStartDate: data.showStartDate,
		endDate: `${data.endDate}T${data.endTime || "00:00"}`,
		showEndDate: data.showEndDate,
		tag: data.tag
	};
}
